import { getCookie, eraseCookie } from './cookieHelper';

const jsonToFormData = (json) => {
    const formData = new FormData();
    if (json && typeof json === 'object') {
        Object.keys(json).forEach(key => {
            const value = json[key];
            if (Array.isArray(value)) {
                value.forEach(v => formData.append(key, v));
            } else {
                formData.append(key, value);
            }
        });
    }
    return formData;
};

const HttpService = async (url, method, data = null) => {
    const token = getCookie('token');

    const headers = {};
    if (token) {
        headers['Authorization'] = `${token}`; // Assuming Bearer token format
    }

    const config = {
        method: method,
        headers: headers,
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            const params = new URLSearchParams(data).toString();
            // Append to URL
            if (url.includes('?')) {
                url += `&${params}`;
            } else {
                url += `?${params}`;
            }
        } else {
            // Convert json to FormData for other methods, or use directly if already FormData
            config.body = data instanceof FormData ? data : jsonToFormData(data);
            // Note: Content-Type is irrelevant for FormData (browser sets boundary)
        }
    }

    // Call fetch with the updated URL (for GET)
    // For GET, we use the modified 'url' variable from the if block scope? 
    // No, string is immutable, we need to make sure we use the modified url.
    // Re-assigning url argument is valid in JS functions (it's local).

    try {
        const response = await fetch(url, config);

        let responseData;
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
            try {
                responseData = await response.json();
            } catch (e) {
                const text = await response.text();
                console.error("Failed to parse JSON even though Content-Type was application/json. Raw response:", text.substring(0, 200));
                responseData = { success: false, message: "Invalid JSON response from server", raw: text };
            }
        } else {
            responseData = await response.text();
            // Try to parse as JSON anyway, but don't crash if it's HTML
            try {
                const parsed = JSON.parse(responseData);
                responseData = parsed;
            } catch (e) {
                // It's probably HTML or plain text
                if (responseData.trim().startsWith("<")) {
                    responseData = {
                        success: false,
                        message: `Server returned HTML instead of JSON (Status: ${response.status})`,
                        isHtml: true
                    };
                }
            }
        }

        if (!response.ok) {
            if (response.status === 401) {
                eraseCookie('token');
                window.localStorage.clear();
                window.location.href = '/';
            }
            const error = new Error(responseData?.message || `API request failed with status ${response.status}`);
            error.response = response;
            error.data = responseData;
            error.status = response.status;
            throw error;
        }

        return responseData;
    } catch (error) {
        // Only log if it's not already handled or if it's a real network error
        if (!error.status) {
            console.error("Network Error:", error.message);
        }
        throw error;
    }
};

const service = {
    get: (url, data) => HttpService(url, 'GET', data),
    post: (url, data) => HttpService(url, 'POST', data),
    put: (url, data) => HttpService(url, 'PUT', data),
    patch: (url, data) => HttpService(url, 'PATCH', data),
    delete: (url, data) => HttpService(url, 'DELETE', data),
};

export default service;
